import { Cell, Row, Table } from '@/main/utils/table';
import { apiProvider } from '@/modules/ciselnik/dilenske/pracovniPozice/api';
import { updateTableSchemaAction } from '@/main/store/actionsFunctions';
import { TABLE_SCHEMA, UPDATE_BASIC_TABLE_SCHEMA } from '@/main/store/listEditTypes';
import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME, CRUMB_LABEL_KEY, SET_LIST_TABLE_SCHEMA, COLUMN_ISEXTERNAL } from '../constants';
import { listMutations, PpFilterEnum } from './types';


const filter = {
	VyrobekvozOzn: null as string | null,
	Tablpozice: null as string | null,
	PpNr: null as string | null,
	ProvozovnaId: null as number | null,
	Type: PpFilterEnum.Default as PpFilterEnum,
	TablpoziceText: null as string | null,
};


export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekvozOzn: [],
	},
	filter,
	tableSetting: {
		isEditable: true,
		columnSettings: {
			[COLUMN_ISEXTERNAL]: { isEditable: true },
		},
	},
	rowDetail: null,
	localState: {
		Schemas: {} as Record<string, Table>,
	},
	extraActions: {
		async [TABLE_SCHEMA](
			{ commit, dispatch, state }, { isSelect = false, type = 0 }: { isSelect: boolean, type: number },
		) {
			return updateTableSchemaAction(
				state,
				commit,
				dispatch,
				apiProvider[isSelect ? 'tableSchemaSelect' : 'tableSchema'](
					{ cancelTokenKey: TABLE_SCHEMA, commit }, type,
				),
				'table',
			);
		},

		[SET_LIST_TABLE_SCHEMA]: (
			{ commit, dispatch, state }, schema = {},
		) => {
			commit(UPDATE_BASIC_TABLE_SCHEMA, { data: schema, tableName: 'table' });
			return schema;
		},
	},
	extraMutations: {
		[listMutations.PRACOVNI_POZICE_TABULKOVA_POZICE_FILTER_SELECT_MAPPER](state, { data, mode }) {
			state.filter.Tablpozice = data.value;
			state.filter.TablpoziceText = data.text;
		},
		[listMutations.PRACOVNI_POZICE_PP_NR_FILTER_SELECT_MAPPER](state, { data, mode }) {
			state.filter.PpNr = data.ppNr ? data.ppNr.trim() : null;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		showFilter: true,
		afterRowSelection: () => {},
	},
});
